import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import shopSetting from '@/utils/shopSetting'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true
})
const loadedLanguages = []

function setI18nLanguage(lang, data) {
  loadedLanguages.push(lang)

  i18n.locale = lang
  i18n.setLocaleMessage(lang, data)

  // document.querySelector('html').setAttribute('lang', lang)
  // return lang
}

async function loadLanguageAsync(lang) {
  // 如果已加载此语言包，直接设置并返回
  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang)
    return Promise.resolve()
  }
  
  // 从本地缓存中获取语言数据
  const cacheKey = `lang_${lang}`
  let cachedData = localStorage.getItem(cacheKey)
  
  if (cachedData) {
    try {
      cachedData = JSON.parse(cachedData)
      // 检查缓存是否有效（可添加过期时间检查）
      if (cachedData && cachedData.data) {
        // 立即设置语言，不等待网络请求
        setI18nLanguage(lang, cachedData.data)
        
        // 无感请求更新缓存
        setTimeout(() => {
          axios.get(`${shopSetting.apiUrl}/api/v1/locale/${lang}`)
            .then(response => {
              if (response.status === 200) {
                // 更新缓存
                localStorage.setItem(cacheKey, JSON.stringify({
                  data: response.data,
                  timestamp: new Date().getTime()
                }))
                
                // 如果当前语言仍然是这个语言，则更新消息
                if (i18n.locale === lang) {
                  i18n.setLocaleMessage(lang, response.data)
                }
              }
            })
            .catch(error => {
              console.log('语言包更新错误:', error)
            })
        }, 0)
        
        return Promise.resolve()
      }
    } catch (error) {
      console.log('语言包缓存解析错误:', error)
    }
  }
  
  // 没有缓存或缓存无效，从网络加载
  try {
    const response = await axios.get(
      `${shopSetting.apiUrl}/api/v1/locale/${lang}`
    )
    if (response.status === 200) {
      // 保存到缓存
      localStorage.setItem(cacheKey, JSON.stringify({
        data: response.data,
        timestamp: new Date().getTime()
      }))
      
      setI18nLanguage(lang, response.data)
    }
  } catch (error) {
    console.log('语言包加载错误:', error)
  }
  
  return Promise.resolve()
}

export { i18n, setI18nLanguage, loadLanguageAsync }